import React from "react";
import { Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

const ColoredBarWithText = ({
  value,      // aktuellt värde
  maxValue,   // maxvärde för procent
  color,      // färg på fyllningen
  unit,       // enhet, t.ex. kWh
  height = 24, // höjd på stapeln
}) => {
  // Räkna bredd %
  const widthPercent = Math.min((value / maxValue) * 100, 100);

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height,
        backgroundColor: "#FFF",
        borderRadius: height / 2,
        overflow: "hidden",
      }}
    >
      {/* Färgad fyllning */}
      <Box
        sx={{
          width: `${widthPercent}%`,
          height: "100%",
          backgroundColor: color,
          borderRadius: height / 2,
          position: "relative",
        }}
      >
        {/* Text centrerad i den färgade fyllningen */}
        <Typography
          sx={{
            position: "absolute",
            left: widthPercent < 20 ? "105%" : "50%",
            ml: widthPercent < 20 ? 0.5 : "",
            top: "50%",
            transform: widthPercent < 20 ? "translateY(-50%)" : "translate(-50%, -50%)",
            fontWeight: 600,
            fontSize: "0.875rem",
            color: widthPercent < 20 ? "#000" : "#FFF",
            whiteSpace: "nowrap",
            pointerEvents: "none",
            textShadow: "0 0 2px rgba(0,0,0,0.4)",
          }}
        >
          {value} {unit}
        </Typography>
      </Box>
    </Box>
  );
};

export default ColoredBarWithText;
